module.exports = __webpack_public_path__ + "static/img/header_logo.83a24c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_logo.png
// module id = oHgo
// module chunks = 8